import { Component, default as React } from 'react';
import { reduxForm } from 'redux-form';
import { Grid, Icon } from 'semantic-ui-react';
import PaginationShorthand from 'shared-components/Pager';
import RenderSelect from 'shared-components/Select';
import * as _func from './function';
import TableHeader from 'shared-components/Table/tableHeader';
import * as header from '../../../../ballot-admin/ballot-admin.model';
import _ from 'lodash';
import { ItemsPerPage } from 'models/common.models';
import ModelComments from '../../../../ballot-admin/components/Model-Comments';
export class ViewVotetHistoryDetails extends Component {

    state = {
        pageNumber: 1,
        pageSize: 25,
        VoteDetailsList: [],
        sortBy: header.Const_VoteDetails_Default_Sort_Column,
        sortOrder: header.Const_VoteDetailsDefault_Sort_Order,
        index: 1,
        TotalRecords: '',
        isOpenModelComment: false,
        CommentList: []
    }

    componentDidMount() {
        _func.setInstance(this);
        _func.resetBallotHeaderInfo(header.VoteDetailsHeader);
        _func.setInitialData(this);
    }

    render() {
        const { VoteDetailsList, pageNumber, pageSize, sortBy, sortOrder, index, TotalRecords, isOpenModelComment, CommentList } = this.state;
        return (
            <div data-testid="ViewVoteHistoryDetailsComp">
                <div>
                    <div className="mt20 mb20 whiteBGBox">
                        <Grid divided='vertically' columns={3}>
                            <Grid.Row>
                                <Grid.Column>
                                    <span className="astm-type-body--lead bold letter-label">Letter Ballot</span>
                                    <span className="labelValue">
                                        {VoteDetailsList?.BallotNumber}
                                    </span>
                                </Grid.Column>
                                <Grid.Column>
                                    <span className="astm-type-body--lead bold letter-label">Vote Date</span>
                                    <span className="labelValue">
                                        {VoteDetailsList?.VoteDate}
                                    </span>
                                </Grid.Column>
                                <Grid.Column>
                                    <span className="astm-type-body--lead bold letter-label">Ballot Submission Status</span>
                                    <span className="labelValue">{VoteDetailsList?.VoteStatus > 0 ? header.ViewHisstoryStatusEnum[VoteDetailsList.VoteStatus] : header.ViewHisstoryStatusEnum[0]}</span>
                                </Grid.Column>
                            </Grid.Row>
                        </Grid>
                    </div>

                    <div class="tableWrapper">
                        <table class="customTable">
                            <thead>
                                <tr>
                                    <TableHeader headerProps={header.VoteDetailsHeader} onClickProps={_func.sortByHandler}></TableHeader>
                                </tr>
                            </thead>
                            <tbody>
                                {VoteDetailsList && _.get(VoteDetailsList, 'BallotVoteItems') && VoteDetailsList.BallotVoteItems.length > 0 && (
                                    VoteDetailsList.BallotVoteItems.map((item, index) => {
                                        return ( <tr key={index}>
                                            <td>{item.BallotItemNumber}</td>
                                            <td>{item.VoteDescription}</td>
                                            <td>{(_.get(item, 'BallotVoteComments') && item.BallotVoteComments.length > 0) && <a onClick={() => _func.openModelComment(index, item)}>View</a>}</td>
                                            <td>
                                            { 
                                            item.IsSourceDMS ? item.DocumentAssetGuid ?
                                            <a href="#" className="astm-link" onClick={(e) => _func.handleBallotFileClick(e, item.DocumentAssetGuid, true)}>{item.FileName}
                                            </a> : 
                                            <span></span> : 
                                            <a href="#" className="astm-link" onClick={(e) => _func.handleBallotFileClick(e, (item.FilePath + "/" + item.FileName), false)}>{item.FileName}
                                            </a>
                                            }
                                            </td>
                                        </tr> )
                                    })
                                )}
                            </tbody>
                        </table>
                        {
                            !_.get(VoteDetailsList, 'BallotVoteItems') && (<div className="noRecordMessage">Vote items not available.</div>)
                        }
                    </div>
                    {VoteDetailsList && _.get(VoteDetailsList, 'BallotVoteItems') && VoteDetailsList.BallotVoteItems.length > 0 && (<section className="pagerWrap" data-testid="pagerWrap">
                        <div className="pager" data-testid="pager">
                            <PaginationShorthand defaultActivePage={pageNumber}
                                totalPages={Math.ceil(TotalRecords / pageSize)}
                                onPageChange={_func.onPageChangeHandler}
                            />
                        </div>
                        <div className="itemPerPage" data-testid="itemPerPage">
                            <RenderSelect
                                value={pageSize} options={ItemsPerPage} onChange={_func.onChangeNumberOfItemsPerPage} />
                            <span className="itemsPerPage">items per page</span>
                        </div>
                        <div className="totalPage" data-testid="totalPage">
                            {(((pageNumber - 1) * pageSize) + 1) + ' - ' + ((((pageNumber - 1) * pageSize)) + VoteDetailsList.BallotVoteItems.length) + ' of '}{VoteDetailsList.BallotVoteItems ? TotalRecords + ' items' : ''}
                        </div>
                    </section>)}
                </div>
                {isOpenModelComment && <ModelComments CommentList={CommentList} onClose={_func.closeModelComment} ></ModelComments>}
            </div>
        )
    }
}
export default (reduxForm({
    form: 'ViewVotetHistoryDetails'
})(ViewVotetHistoryDetails));
